// @file ./src/context/ConfigContext.tsx

import { createContext } from "react";

export const ConfigContext = createContext({
  config: {
    ui: {
      scrollToTopButton: true, // Default sichtbar
    }
  },
  toggleUI: () => {},
});